import { useDebouncedCallback } from '@/lib/use-debounced-callback';
import { TextField } from '@pms-digital/design-system';
import { useEffect, useRef, useState } from 'react';

export interface MatrixSearchInputProps {
  /** The query held in the URL. */
  value: string;
  onChange: (value: string) => void;
}

/** Keystrokes reach the URL (and the filter) after this pause. */
export const SEARCH_DEBOUNCE_MS = 200;

/**
 * « Rechercher un sujet ». Typing is local and pushed to the URL after a
 * short pause, so each keystroke does not become a navigation; a change that
 * comes from elsewhere (a chip removed, « Réinitialiser ») is taken back in.
 */
export function MatrixSearchInput({ value, onChange }: MatrixSearchInputProps) {
  const [text, setText] = useState(value);
  const lastSent = useRef(value);
  const push = useDebouncedCallback((next: string) => {
    lastSent.current = next;
    onChange(next);
  }, SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    if (value === lastSent.current) return;
    lastSent.current = value;
    setText(value);
  }, [value]);

  return (
    <div className="w-[220px]">
      <TextField
        type="search"
        label="Rechercher un sujet"
        hideLabel
        compact
        icon="search"
        placeholder="Rechercher un sujet"
        value={text}
        onChange={(event) => {
          setText(event.target.value);
          push(event.target.value);
        }}
      />
    </div>
  );
}
